module.exports = __webpack_public_path__ + "img/img39.17649318.svg";